import { put, takeLatest } from 'redux-saga/effects';
import { getQueryClientContext } from 'data/core/sagas/query-client';
import { getTemplatesDetailsQueryKey } from 'queries';
import { TemplateObjectType } from '../api';
import { setConditionalVariablesInDocumentTemplate } from '../documents/slices';
import { setConditionalVariablesInProjectTemplate } from '../projects/slices';
import { setConditionalVariablesAction } from './actions';
function* setConditionalVariablesSaga(action) {
    const { payload: { formValues, variableId, templateType, templateId } } = action;
    const queryClient = yield getQueryClientContext();
    switch(templateType){
        case TemplateObjectType.Project:
            yield put(setConditionalVariablesInProjectTemplate({
                variableId,
                formValues,
                templateType
            }));
            break;
        case TemplateObjectType.Document:
            yield put(setConditionalVariablesInDocumentTemplate({
                variableId,
                formValues,
                templateType,
                templateId
            }));
            break;
        case TemplateObjectType.StatusUpdates:
            if (templateId) {
                const _template = queryClient.getQueryData(getTemplatesDetailsQueryKey(templateId));
                queryClient.setQueryData(getTemplatesDetailsQueryKey(templateId), (currentTemplate)=>{
                    var _ref, _ref1;
                    var _currentTemplate_templateMeta;
                    return {
                        ...currentTemplate,
                        templateMeta: {
                            ...(_ref = currentTemplate === null || currentTemplate === void 0 ? void 0 : currentTemplate.templateMeta) !== null && _ref !== void 0 ? _ref : {},
                            conditionalVariables: {
                                ...(_ref1 = currentTemplate === null || currentTemplate === void 0 ? void 0 : (_currentTemplate_templateMeta = currentTemplate.templateMeta) === null || _currentTemplate_templateMeta === void 0 ? void 0 : _currentTemplate_templateMeta.conditionalVariables) !== null && _ref1 !== void 0 ? _ref1 : {},
                                [variableId]: {
                                    formValues
                                }
                            }
                        }
                    };
                });
            }
            break;
        default:
            break;
    }
}
export function* watchTemplateVariableSaga() {
    yield takeLatest(setConditionalVariablesAction.type, setConditionalVariablesSaga);
}
